import React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import { connect } from "react-redux";
import green from '@material-ui/core/colors/green';
import amber from '@material-ui/core/colors/amber';
const styles = theme =>({
        success: {
        backgroundColor: green[600],
      },
      error: {
        backgroundColor: theme.palette.error.dark,
      },
      info: {
        backgroundColor: theme.palette.primary.dark,
      },
      warning: {
        backgroundColor: amber[700],
      },
      icon: {
        fontSize: 20,
      },
      iconVariant: {
        opacity: 0.9,
        marginRight: theme.spacing.unit,
      },
      message: {
        display: 'flex',
        alignItems: 'center',
      },
})

class PositionedSnackbar extends React.Component {
    
    constructor(){
        super()
        this.state = {
            open: false,
            message:''
          }
    }

    

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.configuration !== this.props.configuration) {
           this.setState({open:true, message:"Configuration Saved!"}) 
        }
    }
    handleClick = state => () => {
        this.setState({ open: true, ...state });
      };
    
    handleClose = () => {
        this.setState({ open: false });
      };

      render() {
        const {open,message } = this.state;
        return (
        <div>
            <Snackbar
            autoHideDuration={500}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={open}
            onClose={this.handleClose}
            className={styles.success}
            ContentProps={{
              'aria-describedby': 'message-id',
            }}
            message={<span id="message-id">{message}</span>}
          />
        </div>
        )
        }
    }

    const mapStateToProps = state => {
        return  {...state};
      };
      
     
         
export default connect(mapStateToProps)(PositionedSnackbar)